import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import Header from './Header';

export function PageShell({ children }: { children?: React.ReactNode }) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', backgroundColor: 'background.default' }}>
      {/* ── Header ─────────────────────────────────── */}
      <Header />

      {/* Spacer pushes content below the fixed AppBar */}
      <Box sx={{ height: '70px' }} />

      {/* ── Page content ───────────────────────────── */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: { xs: 2, sm: 3 },
          maxWidth: 1600,
          mx: 'auto',
          width: '100%',
        }}
      >
        {children ?? <Outlet />}
      </Box>
    </Box>
  );
}
